import React, { useState } from "react";
import CustomButton from "../../components/ui/button";
import {
	Box,
	Typography,
	Container,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	CircularProgress,
	Snackbar,
	Alert,
	Stack,
} from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

const Logout = () => {
	const [open, setOpen] = useState(false);
	const [loading, setLoading] = useState(false);
	const [snackbarOpen, setSnackbarOpen] = useState(false);

	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	const handleSnackbarClose = (event, reason) => {
		if (reason === "clickaway") return;
		setSnackbarOpen(false);
	};

	const handleConfirm = async () => {
		setLoading(true);
		try {
			const response = await fetch("/wp-json/tmt-portal/v1/logout", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-WP-Nonce": wpApiSettings.nonce,
				},
			});

			if (response.ok) {
				setSnackbarOpen(true);
				const data = await response.json();
				setTimeout(() => {
					window.location.href = data.redirect_url || "/";
				}, 1200);
			} else {
				console.error("Logout failed:", response.statusText);
				window.location.href = "/wp-login.php?action=logout&redirect_to=/";
			}
		} catch (error) {
			console.error("Logout error:", error);
			window.location.href = "/wp-login.php?action=logout&redirect_to=/";
		} finally {
			setLoading(false);
			handleClose();
		}
	};

	return (
		<Container disableGutters maxWidth={true}>
			<Stack direction="row" spacing={2.2} sx={{ cursor: "pointer", alignItems: "center" }} onClick={handleOpen}>
				<ExitToAppIcon sx={{ fontSize: 20, color: "#1C46B4" }} />
				<Typography variant="body2">Logout</Typography>
			</Stack>

			<Dialog
				open={open}
				onClose={(event, reason) => {
					if (reason === "backdropClick") return;
					handleClose();
				}}
				PaperProps={{ sx: { minWidth: 340, maxWidth: 400 } }}
			>
				<DialogTitle>Confirm Action</DialogTitle>
				<DialogContent>
					<Typography>Are you sure you want to logout?</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="inherit">
						Cancel
					</Button>
					<Button
						onClick={handleConfirm}
						variant="contained"
						disabled={loading}
						sx={{
							bgcolor: "#1C46B4",
							color: "#fff",
							width: 120,
							textTransform: "none",
							borderRadius: "8px",
							boxShadow: "none",
							"&:hover": { bgcolor: "#152E8C" },
						}}
					>
						{loading ? <CircularProgress size={18} color="inherit" /> : "Confirm"}
					</Button>
				</DialogActions>
			</Dialog>

			<Snackbar
				open={snackbarOpen}
				autoHideDuration={1200}
				onClose={handleSnackbarClose}
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
			>
				<Alert onClose={handleSnackbarClose} severity="success" sx={{ width: "100%" }}>
					Successfully logged out.
				</Alert>
			</Snackbar>
		</Container>
	);
};

export default Logout;
